import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { NavigationState } from "./types";

type AssistantPanelLearnStoreState = {
  navigationState: NavigationState;
};

type AssistantPanelLearnStoreActions = {
  setNavigationState: (state: NavigationState) => void;
};

type AssistantPanelLearnStore = AssistantPanelLearnStoreState & AssistantPanelLearnStoreActions;

const useAssistantPanelLearnStore = create<AssistantPanelLearnStore>()(
  persist(
    immer((set) => ({
      navigationState: { level: "groups" },
      setNavigationState: (state) => {
        set(() => ({
          navigationState: state,
        }));
      },
    })),
    {
      name: "assistant-panel-learn-store",
      version: 1,
      partialize: (state) => ({
        navigationState: state.navigationState,
      }),
    }
  )
);

export default useAssistantPanelLearnStore;
